module.exports = __webpack_public_path__ + "img/AI应用.5546e461.png";